<template>
  <!-- 工作流业务配置：每个业务一行，声明状态字段、触发值与回调接口 -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="业务名称/类型" @keydown.enter="resetSearch" clearable>
            <template #prefix>关键字</template>
          </el-input>
          <el-select v-model="searchInfo.status" placeholder="启用状态" @change="resetSearch" clearable>
            <template #prefix>状态</template>
            <el-option label="启用" value="Y"/>
            <el-option label="停用" value="N"/>
          </el-select>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
        </template>
      </search-condition>

      <list-table>
        <yq-table :data="dataList" height="100%" stripe border>
          <yq-table-column label="业务名称" prop="businessType" min-width="120rem">
            <template v-slot="{row}">
              <span>{{ businessNameOf(row.businessType) }}</span>
            </template>
          </yq-table-column>
<!--          <yq-table-column label="业务代码" prop="businessType" min-width="120rem"/>-->
<!--          <yq-table-column label="状态字段" prop="statusField">-->
<!--            <template v-slot="{row}">-->
<!--              <span>{{ row.statusField }} = {{ row.statusTrigger }}</span>-->
<!--            </template>-->
<!--          </yq-table-column>-->
<!--          <yq-table-column label="所属服务" prop="serviceName"/>-->
          <yq-table-column label="启用状态" prop="isEnabled">
            <template v-slot="{row}">
              <el-tag v-if="row.isEnabled === 'Y'" type="success">启用</el-tag>
              <el-tag v-else type="info">停用</el-tag>
            </template>
          </yq-table-column>
          <!--
            业务端只做「日常操作」：启停与编排流程。
            新增/编辑配置、字段映射、删除属于接入期动作，收归运维端（/sys/plat/process）——
            使用方误改状态字段或删掉配置，会直接让审批失效且极难排查。
          -->
          <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="180rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button has-perm="process:setting:save" @click="router.push(`/sys/process/detail?businessType=${row.businessType}`)">流程设置</table-button>
                <table-button has-perm="process:setting:save" @click="changeStatus(row)">
                  {{ row.isEnabled === 'Y' ? '停用' : '启用' }}
                </table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>

      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>

    <!-- 新增/编辑业务配置 -->
    <el-dialog dialog-width="3" :title="configForm.id ? '编辑业务配置' : '新增业务配置'" v-model="showConfigDialog" :close-on-click-modal="false">
      <dialog-table>
        <form-items :columns="2" :data="configForm" ref="configFormRef">
          <form-item label="业务类型" name="businessType" :required="true" error-message="请选择业务类型">
            <el-select v-model="configForm.businessType" placeholder="请选择业务类型" :disabled="!!configForm.id"
                       @change="onBusinessTypeChange">
              <el-option v-for="t in templateList" :key="t.businessType" :label="t.businessName" :value="t.businessType"/>
            </el-select>
            <template #append>
              <el-tooltip content="业务名称取自业务模板，此处无需重复填写">
                <yq-icon name="element-ui_info" style="color: var(--yq-font-color-desc)"/>
              </el-tooltip>
            </template>
          </form-item>
          <form-item label="业务主表名">
            <el-input v-model="configForm.tableName" placeholder="如 order_change，便于运维排查"/>
          </form-item>
          <form-item label="状态字段名" name="statusField" :required="true" error-message="请输入状态字段名">
            <el-input v-model="configForm.statusField" placeholder="如 order_status"/>
          </form-item>
          <form-item label="触发值" name="statusTrigger" :required="true" error-message="请输入触发值">
            <el-input-number v-model="configForm.statusTrigger" :min="0" controls-position="right" style="width:100%"
                             placeholder="如 100"/>
          </form-item>
          <form-item label="业务主键字段" name="bizKeyField">
            <el-input v-model="configForm.bizKeyField" placeholder="默认 id"/>
          </form-item>
          <form-item label="标题字段">
            <el-input v-model="configForm.bizTitleField" placeholder="如 {claimNo} {claimReason}"/>
            <template #append>
              <el-tooltip content="支持模板：{列名} 会被替换成该字段的值，可组合多列，如 {claimNo} {claimReason}。
列表里只显示单号时审批人看不出是什么事，拼上事由才一眼能懂。
不写占位符则整串按单个列名处理。

需要控制显示格式时在列名后加冒号和格式，如 {claimAmount:0.00}（金额两位小数）、
{claimAmount:#,##0.00}（带千分位）、{claimAmount:0}（取整）、{occurDate:yyyy-MM-dd}（日期）。
金额列库里是 4 位小数，不写格式会显示成 100.0000。只影响标题显示，不影响金额本身的精度。">
                <yq-icon name="element-ui_info" style="color: var(--yq-font-color-desc)"/>
              </el-tooltip>
            </template>
          </form-item>
          <form-item label="所属服务名" name="serviceName" :required="true" error-message="请输入服务名">
            <el-input v-model="configForm.serviceName" placeholder="Eureka serviceId，如 order-change"/>
          </form-item>
          <form-item label="审批中拦截">
            <el-select v-model="configForm.lockMode" placeholder="请选择拦截强度">
              <el-option label="不锁" :value="0"/>
              <el-option label="全锁" :value="100"/>
              <el-option label="字段级锁" :value="200"/>
            </el-select>
          </form-item>
          <form-item label="保存接口" :show-block="true">
            <el-input v-model="configForm.apiSave" type="textarea" :rows="2"
                      placeholder="工作流监听入口，多个用英文逗号分隔，如 /order/save,/order/batchSave"/>
            <template #append>
              <el-tooltip content="必须使用 POST 传参，参数为 body，拦截器需要从中取状态值与业务主键">
                <yq-icon name="element-ui_info" style="color: var(--yq-font-color-desc)"/>
              </el-tooltip>
            </template>
          </form-item>
          <form-item label="完结接口" :show-block="true">
            <el-input v-model="configForm.apiComplete" placeholder="流程走完时回调，参数(merchantId, businessId)"/>
          </form-item>
          <form-item label="驳回接口" :show-block="true">
            <el-input v-model="configForm.apiReject" placeholder="审批被驳回时回调，参数(merchantId, businessId)"/>
          </form-item>
          <form-item label="中止接口" :show-block="true">
            <el-input v-model="configForm.apiSuspend" placeholder="流程被撤销/中止时回调，参数(merchantId, businessId)"/>
          </form-item>
          <!--
            详情接口与上面三个回调同属一类：引擎内网调用、不入网关。
            不填也能用，只是审批弹框里看不到单据内容，审批人得自己另开页面查。
          -->
          <form-item label="详情接口" :show-block="true">
            <el-input v-model="configForm.apiDetail" placeholder="审批人查看单据内容时回调，如 /basedata/crm/expense/claim/queryDetail"/>
            <template #append>
              <el-tooltip content="参数(merchantId, id)，返回字段列表 [{label,value,type}]，供审批中心通用组件渲染。
不配置则审批弹框不显示单据内容。
该接口只被引擎内网调用，不要注册到网关——引擎会先校验查看人是否为本流程参与者。">
                <yq-icon name="element-ui_info" style="color: var(--yq-font-color-desc)"/>
              </el-tooltip>
            </template>
          </form-item>
          <form-item label="锁定字段" :show-block="true">
            <el-input v-model="configForm.lockFields" placeholder="字段级锁时禁止修改的字段，逗号分隔，如 amount,customer_id"/>
          </form-item>
          <form-item label="备注" :show-block="true">
            <el-input v-model="configForm.remark" type="textarea" :rows="2" placeholder="备注"/>
          </form-item>
        </form-items>
      </dialog-table>
      <div slot="footer">
        <page-button @click="showConfigDialog = false">取消</page-button>
        <page-button type="write" el-type="primary" @click="saveConfig">保存</page-button>
      </div>
    </el-dialog>

    <!-- 业务设置：维护条件字段与业务节点 -->
    <el-dialog dialog-width="3" title="业务设置" v-model="showFieldDialog" :close-on-click-modal="false">
      <dialog-table>
        <list-page>
          <form-items :columns="1" :data="fieldForm">
            <form-item label="业务类型" name="businessType" :required="true" error-message="请选择业务类型">
              <el-select v-model="fieldForm.businessType" placeholder="请选择业务类型" @change="loadFieldList">
                <el-option v-for="t in templateList" :key="t.businessType" :label="t.businessName" :value="t.businessType"/>
              </el-select>
              <template #append>
                <el-tooltip content="普通字段供审批条件使用；业务节点供流程编排使用（如回填出库序列号）">
                  <yq-icon name="element-ui_info" style="color: var(--yq-font-color-desc)"/>
                </el-tooltip>
              </template>
            </form-item>
          </form-items>
          <!--
            这张表不只服务于条件判断，它同时决定了「发起流程时从业务请求体里采集哪些字段」——
            标题模板的占位符、条件表达式的变量，都只能取到这里登记过的列。
            漏登记的表现是：条件求值 fail-closed 报「没有取到值」，标题占位符原样残留。
          -->
          <div class="field-tip">
            这里登记的列会被工作流采集使用：<b>条件表达式</b>引用它做分支判断，
            <b>标题模板</b>的 <code>{'{'}列名{'}'}</code> 从它取值。
            需要用到的列都要登记，否则会取不到值。
            标题里还可以写成 <code>{'{'}列名:格式{'}'}</code> 控制显示格式，如金额写 <code>{'{'}claimAmount:0.00{'}'}</code> 只显示两位小数。
          </div>
          <list-table>
            <yq-table ref="fieldTable" :data="fieldForm.fieldList" stripe border>
              <yq-table-column label="名称" prop="fieldLabel" min-width="120rem">
                <template v-slot="{row}">
                  <el-input v-model="row.fieldLabel"
                            :placeholder="isBusinessNode(row.fieldType) ? '如 回填出库序列号' : '如 总金额'"/>
                </template>
              </yq-table-column>
              <yq-table-column prop="fieldName" min-width="180rem">
                <!-- 表头随类型变化：普通字段填列名，业务节点填回调接口 -->
                <template #header>
                  <span>列名 / 回调接口</span>
                </template>
                <template v-slot="{row}">
                  <el-input v-model="row.fieldName"
                            :placeholder="isBusinessNode(row.fieldType) ? '如 /warehouse/outbound/complete' : '如 order_amount'"/>
                </template>
              </yq-table-column>
              <yq-table-column label="类型" prop="fieldType" width="160rem">
                <template v-slot="{row}">
                  <el-select v-model="row.fieldType" placeholder="请选择">
                    <el-option label="数值" :value="100"/>
                    <el-option label="字符串" :value="200"/>
                    <el-option label="日期" :value="300"/>
                    <el-option label="布尔" :value="400"/>
                    <el-option label="ID(关联键)" :value="500"/>
                    <el-option label="客户" :value="600"/>
                    <el-option label="职员" :value="700"/>
                    <el-option label="数据字典" :value="800"/>
                    <el-option label="业务节点" :value="900"/>
                  </el-select>
                </template>
              </yq-table-column>
              <yq-table-column label="字典类型" prop="fieldCode" min-width="150rem">
                <template v-slot="{row}">
                  <el-input v-if="isDictionary(row.fieldType)" v-model="row.fieldCode"
                            placeholder="如 EXPENSE_TYPE"/>
                  <span v-else class="muted">—</span>
                </template>
              </yq-table-column>
              <yq-table-column label="备注" prop="remark" min-width="120rem">
                <template v-slot="{row}">
                  <el-input v-model="row.remark" placeholder="备注"/>
                </template>
              </yq-table-column>
              <yq-table-column label="操作" prop="options" :align="'center'" width="90rem" :show-overflow-tooltip="false">
                <template #header>
                  <table-button @click="addFieldRow"><yq-icon name="element-ui_plus"/> 添加</table-button>
                </template>
                <template v-slot="{row, $index}">
                  <table-button el-type="danger" @click="removeFieldRow($index)">移除</table-button>
                </template>
              </yq-table-column>
            </yq-table>
          </list-table>
        </list-page>
      </dialog-table>
      <div slot="footer">
        <page-button @click="showFieldDialog = false">取消</page-button>
        <page-button type="write" el-type="primary" @click="saveFieldList">保存</page-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SearchCondition from "@/components/h5/layout/SearchCondition";
import FormPage from "@/components/h5/layout/FormPage";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import TableButton from "@/components/h5/button/TableButton";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import YqTable from "@/components/h5/table/YqTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import YqIcon from "@/components/YqIcon.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import commonApi from "@/api/commonApi";
import processSettingApi from "@/api/normal/sys/processSettingApi";

/** 新建配置时的默认值 */
function emptyConfig() {
  return {
    id: "", businessType: "", tableName: "",
    bizKeyField: "id", bizTitleField: "",
    statusField: "", statusTrigger: null,
    serviceName: "",
    apiSave: "", apiComplete: "", apiReject: "", apiSuspend: "", apiDetail: "",
    lockMode: 200, lockFields: "",
    isEnabled: "Y", remark: ""
  };
}

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "ProcessSettingList",
  components: {
    YqIcon, YqTable, PageButton, DialogTable, FormItems, FormItem,
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      templateList: [],   // 已对接工作流的业务清单，供下拉选择
      showConfigDialog: false,
      configForm: emptyConfig(),
      showFieldDialog: false,
      fieldForm: { businessType: "", fieldList: [] },
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面
      this.loadTemplateList();
      this.resetSearch();
    }
  },
  methods: {
    queryList() {
      processSettingApi.queryConfigList(this.searchInfo).then(res => {
        this.dataList = res.records;
        this.searchInfo.totalCount = res.totalCount;
      });
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    // 业务模板字典：配置页下拉的数据来源，避免手写 businessType 出错
    loadTemplateList() {
      commonApi.queryBusinessTemplateList().then(list => {
        this.templateList = list || [];
      });
    },
    /* ========== 业务配置 ========== */
    openConfigDialog(row) {
      if (row) {
        processSettingApi.findConfigById(row.id).then(data => {
          this.configForm = data;
          this.showConfigDialog = true;
        });
      } else {
        this.configForm = emptyConfig();
        this.showConfigDialog = true;
      }
    },
    // 业务名称不在配置表里存，统一从业务模板字典取，避免两处数据不一致
    businessNameOf(businessType) {
      const tpl = this.templateList.find(t => t.businessType === businessType);
      return tpl ? tpl.businessName : businessType;
    },
    // 选中业务类型后自动带出主表名，减少重复填写
    onBusinessTypeChange(businessType) {
      if (businessType && !this.configForm.tableName) {
        this.configForm.tableName = businessType;
      }
    },
    saveConfig() {
      if (!this.$refs.configFormRef.validCheck()) {
        return;
      }
      processSettingApi.saveConfig(this.configForm).then(res => {
        this.configForm = res;
        this.showConfigDialog = false;
        this.resetSearch();
      });
    },
    changeStatus(row) {
      const next = row.isEnabled === 'Y' ? 'N' : 'Y';
      processSettingApi.changeConfigStatus(row.id, next).then(() => {
        this.resetSearch();
      });
    },
    deleteData(row) {
      processSettingApi.deleteConfig(row.id).then(() => {
        this.resetSearch();
      });
    },
    /* ========== 业务设置（条件字段 + 业务节点） ========== */
    openFieldDialog(row) {
      this.fieldForm = { businessType: row.businessType, fieldList: [] };
      this.loadFieldList();
      this.showFieldDialog = true;
    },
    // 切换业务类型后重新加载该业务的字段；初始化时也走这里
    loadFieldList() {
      if (!this.fieldForm.businessType) {
        this.fieldForm.fieldList = [];
        this.refreshFieldTable();
        return;
      }
      processSettingApi.queryFieldList(this.fieldForm.businessType).then(list => {
        this.fieldForm.fieldList = list || [];
        this.refreshFieldTable();
      });
    },
    /**
     * yq-table 内部维护了一份 dataList 副本，只有 showDataColumns() 会重新同步。
     * 直接 push/splice 不会触发（组件的 watch 监听的是数组引用，增删元素不改引用），
     * 因此每次改动后必须显式刷新。
     */
    refreshFieldTable() {
      this.$nextTick().then(() => {
        const table = this.$refs.fieldTable;
        if (table && table.showDataColumns) {
          table.showDataColumns();
        }
      });
    },
    // field_type=900 是业务节点，其 field_name 存的是回调接口地址而非列名
    isBusinessNode(fieldType) {
      return fieldType === 900;
    },
    /** 数据字典类型：需要额外填字典类型编码，条件编辑器据此拉下拉选项 */
    isDictionary(fieldType) {
      return fieldType === 800;
    },
    addFieldRow() {
      this.fieldForm.fieldList.push({ fieldLabel: "", fieldName: "", fieldCode: "", fieldType: 100, remark: "" });
      this.refreshFieldTable();
    },
    removeFieldRow(index) {
      this.fieldForm.fieldList.splice(index, 1);
      this.refreshFieldTable();
    },
    saveFieldList() {
      if (!this.fieldForm.businessType) {
        this.$message.error("请先选择业务类型");
        return;
      }
      // 前端先拦一道给出明确提示；后端有同样的校验兜底
      const list = this.fieldForm.fieldList || [];
      for (let i = 0; i < list.length; i++) {
        const row = list[i];
        if (!row.fieldLabel) {
          this.$message.error(`第 ${i + 1} 行的名称不能为空`);
          return;
        }
        if (!row.fieldName) {
          this.$message.error(this.isBusinessNode(row.fieldType)
              ? `业务节点【${row.fieldLabel}】的回调接口地址不能为空`
              : `字段【${row.fieldLabel}】对应的列名不能为空`);
          return;
        }
      }
      processSettingApi.saveFieldList(this.fieldForm).then(() => {
        this.showFieldDialog = false;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.field-tip {
  font-size: 12px;
  line-height: 1.8;
  color: #909399;
  background: #fafbfc;
  border: 1px solid var(--yq-border-color, #ebeef5);
  border-radius: 6px;
  padding: 8px 12px;
  margin-bottom: 10px;

  b {
    color: #606266;
  }

  code {
    font-family: Consolas, Menlo, monospace;
    background: #f0f2f5;
    border-radius: 3px;
    padding: 0 3px;
  }
}
</style>
